import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
   palette: {
      mode: 'dark',
      // primary: {
      //    main: '#3f51b5',
      // },
      // secondary: {
      //    main: '#f50057',
      // },
      // error: {
      //    main: '#f44336',
      // },
      // warning: {
      //    main: '#ff9800',
      // },
      // info: {
      //    main: '#2196f3',
      // },
      // success: {
      //    main: '#4caf50',
      // },
   },
});
